import {useEffect} from 'react';
import {toast} from 'sonner';

import {useWhatsNewData} from 'modules/decisionsNext/sections/WhatsNewSection/useWhatsNewData';
import {
  setHasAlreadySeenWhatsNewPage,
  setNewFeaturesCount,
} from 'modules/decisionsNext/sections/WhatsNewSection/whatsNewPageStore';
import {dayjs} from 'utils/dateUtils';
import {getWhatsNewPageSettings} from 'modules/decisionsNext/sections/WhatsNewSection/api/getWhatsNewPageSettings';
import {useFeatureFlag} from 'core/hooks/authHooks';
import {FeatureFlags} from 'core/constants/featureFlags';

export function useDetectNewFeatures(withDecisions: boolean) {
  const {allItems} = useWhatsNewData();
  const withWhatsNewPage = useFeatureFlag(FeatureFlags.WhatsNew);

  useEffect(() => {
    if (!withDecisions || !withWhatsNewPage) {
      return;
    }

    const loadData = async () => {
      try {
        const data = await getWhatsNewPageSettings();
        return data.data;
      } catch {
        toast.error('There was an error loading Whats New page settings');
      }
    };

    loadData().then(data => {
      if (!data) {
        return;
      }

      const previousDateToSeeUpdates = data?.userPageSettings?.customSettings?.[0]?.value;

      if (!previousDateToSeeUpdates) {
        setHasAlreadySeenWhatsNewPage(false);
      }

      const newItems = previousDateToSeeUpdates
        ? allItems.filter(item => item.isNew && dayjs(item.date).isAfter(previousDateToSeeUpdates))
        : allItems.filter(item => item.isNew);

      setNewFeaturesCount(newItems.length > 0 ? newItems.length : 0);
    });
  }, [allItems, withDecisions, withWhatsNewPage]);
}
